<template>
  <div>
    <h1 class="case-detail-title">{{$t('editCase.patientInformation')}}</h1>
    <div style="height: 560px;overflow-y:scroll;overflow-x:hidden;">
      <Form ref="formCasePatient" :model="patInfo" :rules="ruleCasePatient" :label-width="140" label-position="left">
        <Row type="flex" justify="space-around">
          <Col span="12">
            <FormItem :label="$t('addNewCase.patientInfo.name')" prop="pat_name">
              <Input v-model="patInfo.pat_name" maxlength="15" style="width: 150px"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem :label="$t('addNewCase.patientInfo.gender')" prop="pat_sex">
              <RadioGroup  v-model="patInfo.pat_sex">
                <Radio  v-for="item in sexs" :value="item.label" :key="item.label" :label="item.label">{{ item.value }}</Radio>
              </RadioGroup>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="space-around">
          <Col span="12">
            <FormItem :label="$t('addNewCase.patientInfo.age')" prop="pat_age">
              <InputNumber v-model="patInfo.pat_age" :min="0" :max="200" style="width: 150px"></InputNumber>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem :label="$t('addNewCase.patientInfo.consultationNumber')">
              <Input v-model="patInfo.pat_vis_id" maxlength="20" style="width: 150px"></Input>
            </FormItem>
          </Col>
        </Row>
        <div v-show="isShowMoreOne">
          <Row type="flex" justify="space-around">
            <Col span="12">
              <FormItem label="证件类型：">
                <Select v-model="patInfo.pat_no_type" style="width: 150px">
                  <Option v-for="item in zjlxList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="证件号码：">
                <Input v-model="patInfo.pat_no" maxlength="18" style="width: 150px"></Input>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-around">
            <Col span="12">
              <FormItem :label="$t('addNewCase.patientInfo.medicalInsuranceCardNumber')">
                <Input v-model="patInfo.pat_miid" maxlength="25" style="width: 150px"></Input>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem :label="$t('addNewCase.patientInfo.dateOfBirth')">
                <DatePicker v-model="patInfo.pat_birthday" type="date" style="width: 150px" placement="left-start"></DatePicker>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-around">
            <Col span="12">
              <FormItem label="联系电话：" prop="pat_tellphone">
                <Input v-model="patInfo.pat_tellphone" maxlength="11" style="width: 150px"></Input>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="检验单号：" prop="jyCode">
                <Input v-model="patInfo.jyCode" maxlength="11" style="width: 150px"></Input>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-around">
            <Col span="24">
              <FormItem label="住址：">
                <Input v-model="patInfo.pat_address" maxlength="100" style="width:97%"></Input>
              </FormItem>
            </Col>
          </Row>
        </div>
        <Row @click.native="showMoreOne" style="height:40px; line-height:40px;">
          <Col span="6" style="position: relative; top: -10px;margin-left: 25px">
            <a style="font-size: 16px; font-weight: 500; color: #2db7f5" >
              <span>{{moreText1}}</span>
              <Icon v-if="!isShowMoreOne" type="ios-arrow-down"></Icon>
              <Icon v-if="isShowMoreOne" type="ios-arrow-up"></Icon>
            </a>
          </Col>
        </Row>
        <Row style="background-color: #e9eaec;height: 1px;margin-bottom: 40px;"></Row>
        <div class="case-detail-clear"></div>
        <Row type="flex" justify="space-around">
          <Col span="12">
            <FormItem :label="$t('addNewCase.caseInfo.pathologyNumber')" prop="pathology_id">
              <Input v-model="patInfo.pathology_id" maxlength="15" style="width: 150px"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem :label="$t('addNewCase.caseInfo.rapidCase')" prop="is_quick_case">
              <RadioGroup v-model="patInfo.is_quick_case">
                <Radio  v-for="item in isQuicks" :value="item.label" :key="item.label" :label="item.label">{{ item.value }}</Radio>
              </RadioGroup>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="space-around">
          <Col span="12">
            <FormItem :label="$t('addNewCase.caseInfo.caseType')" prop="pathology_type">
              <Select v-model="patInfo.pathology_type" style="width: 150px">
                <Option v-for="item in bllxList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem :label="$t('addNewCase.caseInfo.inspectionDepartment')" >
              <Select v-model="patInfo.case_depart" style="width: 150px" clearable filterable allow-create @on-create="pushSjbmList">
                <Option v-for="item in sjbmList" :value="item.label" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="space-around">
          <Col span="12">
            <FormItem :label="$t('addNewCase.caseInfo.inspectionDate')" prop="send_date">
              <DatePicker v-model="patInfo.send_date" type="date" style="width: 150px" placement="right"></DatePicker>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem :label="$t('addNewCase.caseInfo.sendingDoctor')" prop="send_doctor">
              <Input v-model="patInfo.send_doctor" maxlength="15" style="width: 150px"></Input>
            </FormItem>
          </Col>
        </Row>
        <!--=====================送检医院位置 start=================-->
        <Row type="flex" justify="space-around">
          <Col span="24">
            <FormItem :label="$t('addNewCase.caseInfo.sentToHospital')" labelWidth:80 prop="hospital_id">
              <Select v-model="patInfo.hospital_id" style="width:97%">
                <Option v-for="item in sendHospitalList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <div class="case-detail-clear"></div>
        <div v-show="isShowMoreTwo">
          <Row type="flex" justify="space-around">
            <Col span="12">
              <FormItem :label="$t('addNewCase.caseInfo.hospitalNumber')">
                <Input v-model="patInfo.pat_inhospital_id" maxlength="15" style="width: 150px"></Input>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem :label="$t('addNewCase.caseInfo.ward')">
                <Input v-model="patInfo.pat_ward_area" maxlength="15" style="width: 150px"></Input>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-around">
            <Col span="12">
              <FormItem :label="$t('addNewCase.caseInfo.bedNumber')">
                <Input v-model="patInfo.pat_bed_id" maxlength="15" style="width: 150px"></Input>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem :label="$t('addNewCase.caseInfo.phoneNumberOfSendingPhysician')" prop="send_doctor_phone">
                <Input type="text" :placeholder="$t('addNewCase.caseInfo.phoneNumberOfSendingPhysicianPlaceholder')" maxlength="11" style="width: 150px" v-model="patInfo.send_doctor_phone"></Input>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-around">
            <Col span="12">
              <FormItem :label="$t('addNewCase.caseInfo.menstruateLastTime')">
                <DatePicker v-model="patInfo.last_transit_time" type="date" style="width: 150px"></DatePicker>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem :label="$t('addNewCase.caseInfo.deadline')">
                <DatePicker v-model="patInfo.deadline" type="datetime" :placeholder="$t('addNewCase.caseInfo.deadlinePlaceholder')" style="width: 150px" placement="left" format="yyyy-MM-dd HH:mm:ss"></DatePicker>
              </FormItem>
            </Col>
          </Row>
          <FormItem :label="$t('addNewCase.caseInfo.medicalHistory')" class="case-detail-form-item" style="width: 100%;height:50px;margin-bottom: 20px;">
            <Input type="textarea" v-model="patInfo.medical_history" maxlength="255" show-word-limit :autosize="{minRows: 2,maxRows: 5}"></Input>
          </FormItem>
          <FormItem :label="$t('addNewCase.caseInfo.clinicalDiagnosis')" class="case-detail-form-item" style="width: 100%;height:50px;margin-bottom: 20px;">
            <Input type="textarea" v-model="patInfo.clinical_diagnosis" maxlength="255" show-word-limit :autosize="{minRows: 2,maxRows: 5}"></Input>
          </FormItem>
          <FormItem :label="$t('addNewCase.caseInfo.visibleToTheNakedEye')" class="case-detail-form-item" style="width: 100%;height:50px;margin-bottom: 20px;">
            <Input type="textarea" v-model="patInfo.case_desc" maxlength="255" show-word-limit :autosize="{minRows: 2,maxRows: 5}"></Input>
          </FormItem>
        </div>
        <Row @click.native="showMoreTwo" style="height:40px;line-height:40px;">
          <Col span="6" style="position: relative; top: -10px;margin-left: 25px">
            <a style="font-size: 16px; font-weight: 500; color: #2db7f5" >
              <span>{{moreText2}}</span>
              <Icon v-if="!isShowMoreTwo" type="ios-arrow-down"></Icon>
              <Icon v-if="isShowMoreTwo" type="ios-arrow-up"></Icon>
            </a>
          </Col>
        </Row>
        <Row style="background-color: #e9eaec;height: 1px;margin-bottom: 10px;"></Row>
        <div class="case-detail-clear"></div>
        <div style="margin: 20px auto;text-align: center;">
          <Button type="primary" size="large" @click.native="patFormValidate('formCasePatient')" style="width: 80px;margin: 0 30px;">{{$t('editCase.save')}}</Button>
        </div>
      </Form>
    </div>
  </div>
</template>

<script>
import {formatDate} from '../../../../utils/date'
export default {
  components: {formatDate},
  props: ['zjlxList', 'bllxList', 'sjbmList', 'bllbList', 'fxffList', 'rslxList', 'patInfo'],
  data () {
    // 验证手机号码
    const patTellphone = (rule, value, callback) => {
      let reg = /(^1(2|3|4|5|6|7|8)\d{9}$)/
      if (value === '' || value === undefined) {
        callback()
      } else if (!reg.test(value)) {
        callback(new Error(this.$t('addNewCase.patientInfo.correctContactNumber')))
      } else {
        callback()
      }
    }
    return {
      sendHospitalList: '', // 医院列表
      isShowMoreOne: false,
      isShowMoreTwo: false,
      moreText1: this.$t('addNewCase.moreInformation'),
      moreText2: this.$t('addNewCase.moreInformation'),
      // 性别
      sexs: [
        {
          value: this.$t('addNewCase.patientInfo.menAndWomen.male'),
          label: '1'
        },
        {
          value: this.$t('addNewCase.patientInfo.menAndWomen.female'),
          label: '0'
        }
      ],
      // 是否快速
      isQuicks: [
        {
          value: this.$t('addNewCase.caseInfo.isFast.yes'),
          label: '1'
        },
        {
          value: this.$t('addNewCase.caseInfo.isFast.no'),
          label: '0'
        }
      ],
      /* formCasePatient: {
        pat_name: '',
        pat_sex: '',
        pat_age: 0,
        pathology_id: '',
        is_quick_case: '',
        case_subject: '',
        case_depart: '',
        send_doctor: '',
        send_date: null
      }, */
      ruleCasePatient: {
        pat_name: [
          { required: true, message: this.$t('addNewCase.patientInfo.namePlaceholder'), trigger: 'change' }
        ],
        pat_sex: [
          { required: true, message: this.$t('addNewCase.patientInfo.namePlaceholder'), trigger: 'change' }
        ],
        pat_age: [
          {required: true, type: 'number', message: this.$t('addNewCase.patientInfo.genderTip'), trigger: 'change'}
        ],
        pathology_id: [
          { required: true, message: this.$t('addNewCase.caseInfo.pathologyNumberTip'), trigger: 'change' }
        ],
        is_quick_case: [
          { required: true, message: this.$t('addNewCase.caseInfo.fastTip'), trigger: 'change' }
        ],
        pathology_type: [
          { required: true, message: this.$t('addNewCase.caseInfo.CaseTypeTip'), trigger: 'change' }
        ],
        // case_depart: [
        //   { required: true, message: this.$t('addNewCase.caseInfo.inspectionDepartmentTip'), trigger: 'change' }
        // ],
        send_doctor: [
          { required: true, message: this.$t('addNewCase.caseInfo.sendingDoctorMessage'), trigger: 'change' }
        ],
        hospital_id: [
          { required: true, message: this.$t('addNewCase.caseInfo.sentToHospitalTip'), trigger: 'change' }
        ],
        send_date: [
          { required: true, type: 'date', message: this.$t('addNewCase.caseInfo.inspectionDatePlaceholder'), trigger: 'change' }
        ],
        pat_tellphone: [
          { required: false, validator: patTellphone, trigger: 'blur' }
        ],
        send_doctor_phone: [
          { required: false, validator: patTellphone, trigger: 'blur' }
        ]
      }
    }
  },
  beforeMount () {
    this.$vue = this
    this.getHospitalList()
  },
  computed: {
    bothPropsHaveValue () {
      // 根据您的数据结构和需要，您可能需要修改这里的判断逻辑
      return this.patInfo && this.sjbmList && this.sjbmList.length > 0
    }
  },
  watch: {
    bothPropsHaveValue (newVal) {
      if (newVal) { // 当bothPropsHaveValue为true时执行你的代码逻辑
        // 这里是您希望在两个 props 都有值时执行的代码
        this.pushSjbmList(this.patInfo.case_depart)
      }
    }
    // patInfo (val) {
    //   if (this.patInfo.case_depart !== undefined && this.sjbmList) {
    //     let keshi = this.patInfo.case_depart
    //     let isKeshi = false
    //     this.sjbmList.forEach((item, index, array) => {
    //       if (item.label === keshi) {
    //         isKeshi = true
    //       }
    //     })
    //     if (!isKeshi) {
    //       const sjbm = {
    //         label: this.patInfo.case_depart,
    //         value: this.sjbmList.length
    //       }
    //       this.sjbmList.push(sjbm)
    //     }
    //   }
    // }
  },
  methods: {
    pushSjbmList (val) {
      // 检查val是否已经存在于sjbmList中
      const exists = this.sjbmList.some(item => item.label === val)
      // 如果val不存在，则添加它
      if (!exists) {
        this.sjbmList.push({
          value: val,
          label: val
        })
      }
    },
    // 获取医院列表
    async getHospitalList () {
      let params = new URLSearchParams()
      let suc = await this.$http.post(this.$vue.getData('GET_HOSPITAL_LIST_URL'), params)
      if (suc.data.result === '1') {
        let data = suc.data.data
        this.sendHospitalList = data
      }
    },
    dateToString (date) {
      var year = date.getFullYear()
      var month = (date.getMonth() + 1).toString()
      var day = (date.getDate()).toString()
      if (month.length === 1) {
        month = '0' + month
      }
      if (day.length === 1) {
        day = '0' + day
      }
      var dateTime = year + '-' + month + '-' + day
      return dateTime
    },
    stringToDate (fDate) {
      var fullDate = fDate.split('-')
      return new Date(fullDate[0], fullDate[1] - 1, fullDate[2], 0, 0, 0)
    },
    showMoreOne () {
      this.isShowMoreOne = !this.isShowMoreOne
      if (this.isShowMoreOne) {
        this.moreText1 = this.$t('addNewCase.collapseInformation')
      } else {
        this.moreText1 = this.$t('addNewCase.moreInformation')
      }
    },
    showMoreTwo () {
      this.isShowMoreTwo = !this.isShowMoreTwo
      if (this.isShowMoreTwo) {
        this.moreText2 = this.$t('addNewCase.collapseInformation')
      } else {
        this.moreText2 = this.$t('addNewCase.moreInformation')
      }
    },
    patFormValidate (name) {
      // debugger
      let that = this
      // 此处因为send_date是一个时间戳，没有 getTime 方法，故需要将其转换为一个时间对象后，再去校验
      that.patInfo.send_date = new Date(that.patInfo.send_date)
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.warning()
        }
      })
    },
    // 修改病人病例详情信息
    async save (name) {
      let params = new URLSearchParams()
      params.append('patInfo', JSON.stringify(this.patInfo))
      if (undefined !== this.patInfo.pat_birthday) {
        params.append('pat_birthday', this.dateToString(new Date(this.patInfo.pat_birthday)))
      }
      if (undefined !== this.patInfo.last_transit_time) {
        params.append('last_transit_time', this.dateToString(new Date(this.patInfo.last_transit_time)))
      }
      if (undefined !== this.patInfo.send_date) {
        params.append('send_date', this.dateToString(new Date(this.patInfo.send_date)))
      }
      if (undefined !== this.patInfo.deadline) {
        params.append('deadline', formatDate(this.patInfo.deadline, 'yyyy-MM-dd hh:mm:ss')) // 截止日期
      }
      // let myDate = this.stringToDate('2018-08-08')
      // params.append('myDate', myDate)
      let suc = await this.$http.post(this.$vue.getData('GET_EDIT_CASE_PATIENT_URL'), params)
      if (suc.data.result === '1') {
        this.success()
      } else {
        this.warning()
      }
    },
    // 保存成功消息提醒
    success () {
      this.$Notice.success({
        title: this.$t('caseList.messageNotification'),
        desc: this.$t('editCase.saveSuccess')
      })
    },
    // 保存失败消息提醒
    warning () {
      this.$Notice.error({
        title: this.$t('caseList.messageNotification'),
        desc: this.$t('editCase.saveFailure')
      })
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .case-detail-title
    font-weight bolder
    font-size 20px
    color #2d8cf0
    margin-bottom 24px
  .case-detail-form-item
    width 44%
    display inline-block
    padding-right 2%
    height 40px
    line-height 40px
    font-size 20px
  .case-detail-form-item-address
    width 90%
    display inline-block
    padding-right 2%
    height 40px
    line-height 40px
    font-size 20px
  .case-detail-clear
    clear both
</style>



// WEBPACK FOOTER //
// src/components/case/caseManager/caseDetail/Patient.vue